module.exports = __webpack_public_path__ + "img/qrcode.15f0b9b1.png";